import React, { useEffect, useState } from "react";
import { Card, Box, Typography } from "@mui/material";
import api from "../../utils/api";

const GreetingCard = ({ userFullName, currentTime }) => {
  const [companyName, setCompanyName] = useState("");

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const res = await api.get("/companies");
        if (Array.isArray(res.data) && res.data.length > 0) {
          setCompanyName(res.data[0].Name);
        } else if (res.data?.Name) {
          setCompanyName(res.data.Name);
        }
      } catch (err) {
        console.error("❌ Failed to fetch company name:", err);
      }
    };
    fetchCompany();
  }, []);

  const parseHour = (timeStr) => {
    const match = timeStr.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i);
    if (!match) return null;
    let [_, hour, minute, meridian] = match;
    hour = parseInt(hour, 10);
    if (meridian.toUpperCase() === "PM" && hour !== 12) hour += 12;
    if (meridian.toUpperCase() === "AM" && hour === 12) hour = 0;
    return hour;
  };

  const getGreeting = () => {
    const hour = parseHour(currentTime);
    if (hour === null) return "Hello";
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  const getFormattedDate = () => {
    const today = new Date();
    return today.toLocaleDateString(undefined, {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <Card
      sx={{
        borderRadius: "14px",
        px: 2.5,
        py: 1.5,
        background: "linear-gradient(135deg, #2f63ad, #5c8fdb)",
        color: "white",
        mb: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 1,
        boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
      }}
    >
      {/* Left Section */}
      <Box sx={{ minWidth: 0 }}>
        {companyName && (
          <Typography
            variant="caption"
            sx={{
              opacity: 0.85,
              fontWeight: 500,
              letterSpacing: 0.3,
              display: "block",
            }}
          >
            {companyName}
          </Typography>
        )}

        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 700,
            lineHeight: 1.2,
          }}
        >
          {getGreeting()}, {userFullName}.
        </Typography>
      </Box>

      {/* Right Section */}
      <Box sx={{ textAlign: "right" }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 600,
            letterSpacing: 0.5,
            lineHeight: 1.2,
          }}
        >
          {currentTime}
        </Typography>

        <Typography
          variant="caption"
          sx={{
            opacity: 0.9,
            display: "block",
          }}
        >
          {getFormattedDate()}
        </Typography>
      </Box>
    </Card>
  );
};

export default GreetingCard;